module.exports = __webpack_public_path__ + "static/img/4.a30ac13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/booking/profile/4.png
// module id = M7ai
// module chunks = 1